import React from "react";
import * as _ from "lodash";

import { Row, Col, Box, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta } from "@intechprev/componentes-web";

import { Page } from "../";
import { HomeCard } from "./HomeCard";
import { PlanoVinculadoService, ProcessoBeneficioService, FichaFinancAssistidoService, FichaContribPrevidencialService } from "../../services";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from "../../entidades";
import Quotas from "./Quotas";
import moment from "moment";
import { Dependentes } from "./Dependentes";
import { Contato } from "./Contato";

interface Props {
  page: any;
  plano: PlanoVinculadoEntidade;
}

interface State {
  plano: any;
  processo: ProcessoBeneficioEntidade;
  ficha: Array<any>;
  quotas: any[];
}

export class HomeAssistido extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      plano: {},
      processo: null,
      ficha: null,
      quotas: [],
    }
  }

  async componentDidMount() {
    await this.carregarPlano();
  }

  carregarPlano = async () => {
    await this.props.page.current.loading(true);

    await this.carregarDados(this.props.plano);

    await this.props.page.current.loading(false);
  }

  carregarDados = async (plano: PlanoVinculadoEntidade) => {
    var processo = await ProcessoBeneficioService.BuscarPorPlano(plano.SQ_PLANO_PREVIDENCIAL);
    var ficha = await FichaFinancAssistidoService.BuscarUltimaPorProcesso(processo.SQ_PROCESSO);
    var quotas = await FichaContribPrevidencialService.BuscarQuotas(plano.SQ_PLANO_PREVIDENCIAL);

    this.setState({ plano, processo, ficha, quotas });
  }

  render() {
    return (
      <div>
        {this.state.ficha &&
          <div>
            <Row>
              <Col>
                <HomeCard titulo={"Plano"}>
                  {this.state.plano.DS_PLANO_PREVIDENCIAL}
                  <br />
                  <small>
                    <span style={{ "fontWeight": "normal" }}>
                      {`CNPB: ${this.props.plano.NR_CODIGO_CNPB}`}
                    </span>
                  </small>
                </HomeCard>
              </Col>
              <Col>
                <HomeCard titulo={"Situação"}>
                  {this.state.plano.DS_SIT_PLANO}
                </HomeCard>
              </Col>
            </Row>

            <Row className={"mt-4"}>
              <Col>
                <HomeCard titulo={"Benefício"}>
                  {this.state.processo.DS_ESPECIE}
                </HomeCard>
              </Col>
              <Col>
                <HomeCard titulo={"Processo"}>
                  {this.state.processo.NR_PROCESSO}/{this.state.processo.NR_ANO_PROCESSO}
                </HomeCard>
              </Col>
            </Row>

            <Row className={"mt-4"}>
              <Col>
                <HomeCard titulo={"Data Concessão"}>
                  {this.state.processo.DT_CONCESSAO}
                </HomeCard>
              </Col>
              <Col>
                <HomeCard titulo={"Situação"}>
                  {this.state.processo.DS_MOT_SITUACAO}
                </HomeCard>
              </Col>
            </Row>

            <Row className={"mt-4"}>
              <Col>
                {this.state.ficha.length > 0 &&
                  <Box titulo={"Última Folha "} label={`Referência: ${moment(this.state.ficha[0].DT_COMPETENCIA, 'DD/MM/YYYY').format('MM/YYYY')}`}>

                    <h3 className={"text-center text-primary mb-5"}>
                      Valor Líquido: <b className={"text-secondary"}><CampoEstatico valor={_.sumBy(this.state.ficha, 'VL_CALCULO')} tipo={TipoCampoEstatico.dinheiro} /></b>
                    </h3>

                    <table className={"table table-striped table-sm"}>
                      <thead>
                        <tr>
                          <th>Rubrica</th>
                          <th className={"text-right"}>Tipo</th>
                          <th className={"text-right"}>Valor</th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.ficha.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.DS_RUBRICA}</td>
                              <td className={"text-right"}>{item.DS_LANCAMENTO}</td>
                              <td className={"text-right"}>
                                <CampoEstatico valor={item.VL_CALCULO} tipo={TipoCampoEstatico.dinheiro} />
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>

                  </Box>
                }

                {this.state.ficha && this.state.ficha.length == 0 &&
                  <Alerta tipo={TipoAlerta.danger} mensagem="Não foi possível buscar sua última folha" />
                }
              </Col>
              <Col>
                <Box titulo={"Saldo Reserva"}>
                  <h3 className={"text-center text-secondary"}>Seu Saldo de Reserva</h3>

                  {this.state.processo.VL_SALDO_ATUAL === 0 &&
                    <h3 className={"text-center text-primary mb-5"}>Não disponível</h3>
                  }
                  {this.state.processo.VL_SALDO_ATUAL > 0 &&
                    <>
                      <h3 className={"text-center text-primary"}>
                        {this.state.processo.VL_SALDO_ATUAL > 0 &&
                          `${this.state.processo.VL_SALDO_ATUAL.toLocaleString('pt-br', { minimumFractionDigits: 6, maximumFractionDigits: 6 })} Quotas`
                        }
                      </h3>

                      <h3 className={"text-center text-primary mb-5"}>
                        <CampoEstatico
                          valor={this.state.processo.VL_SALDO_ATUAL * (this.state.quotas[1].Value.toString().replace(',', '.'))}
                          tipo={TipoCampoEstatico.dinheiro}
                        />
                      </h3>
                    </>
                  }

                  <Quotas quotas={this.state.quotas} />
                </Box>
              </Col>
            </Row>

            <Dependentes SqPlano={this.state.plano.SQ_PLANO_PREVIDENCIAL} />

            <Contato />
          </div>
        }
      </div>
    );
  }
}
